import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import { ProductID } from '../../../models/product.model';
import {
  Aluminum,
  AluminumProfile,
  Copper,
  CopperPipe,
  CopperSheet,
  MetalMaterial,
  MetalProducts,
  MetalPropertyName,
  Steel,
  SteelStructural,
} from './metal.model';

const structuralConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.AmountScrapBased,
  map: {
    [SteelStructural.None]: MetalProducts.SteelStructuralNone,
    [SteelStructural.Percent100]: MetalProducts.SteelStructuralPercent100,
  },
};

const steelConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.Form,
  map: {
    [Steel.FastenersAndFitting]: MetalProducts.SteelFastenersAndFitting,
    [Steel.LightWeightProfile]: MetalProducts.SteelLightWeightProfile,
    [Steel.PipeStainless]: MetalProducts.SteelPipeStainless,
    [Steel.Rebar]: MetalProducts.SteelRebar,
    [Steel.RebarStainless]: MetalProducts.SteelRebarStainless,
    [Steel.Sheet]: MetalProducts.SteelSheet,
    [Steel.SheetStainless]: MetalProducts.SteelSheetStainless,
    [Steel.Structural]: structuralConditionalProducts,
    [Steel.Wire]: MetalProducts.SteelWire,
  },
};

const profileConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.AmountScrapBased,
  map: {
    [AluminumProfile.None]: MetalProducts.AluminumProfileNone,
    [AluminumProfile.Percent100]: MetalProducts.AluminumProfilePercent100,
  },
};

const aluminumConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.Form,
  map: {
    [Aluminum.Profile]: profileConditionalProducts,
    [Aluminum.Sheet]: MetalProducts.AluminumSheet,
  },
};

const pipeConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.AmountScrapBased,
  map: {
    [CopperPipe.Percent51]: MetalProducts.CopperPipePercent51,
    [CopperPipe.Percent100]: MetalProducts.CopperPipePercent100,
  },
};

const sheetConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.AmountScrapBased,
  map: {
    [CopperSheet.Percent51]: MetalProducts.CopperSheetPercent51,
    [CopperSheet.Percent97]: MetalProducts.CopperSheetPercent97,
  },
};

const copperConditionalProducts: IConditionalNode<MetalProducts> = {
  property: MetalPropertyName.Form,
  map: {
    [Copper.Pipe]: pipeConditionalProducts,
    [Copper.Sheet]: sheetConditionalProducts,
    [Copper.Wire]: MetalProducts.CopperWire,
  },
};

export const metalProductIds: IConditionalNode<ProductID> = {
  property: MetalPropertyName.Material,
  map: {
    [MetalMaterial.Steel]: [steelConditionalProducts],
    [MetalMaterial.Aluminum]: [aluminumConditionalProducts],
    [MetalMaterial.Copper]: [copperConditionalProducts],
  },
};
